import { first } from 'lodash'

export function getToday() {
  return new Date()
}

export function getFormFormattedDate(date: Date) {
  return first(date.toISOString().split('T'))
}
